<template>
  <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main " >
    <div class="container-fluid">
      <!-- Toggler -->
      <navbar-toggle-button @click.native="showSidebar"></navbar-toggle-button>

      <router-link class="navbar-brand" to="/dashboard">
        <img :src="Logo_Negativo" class="navbar-brand-img" alt="Sims">
      </router-link>

      <slot></slot>
      <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">
        <hr class="my-1">
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <h1 class="fw-Bold">SIMS</h1>
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"></slot>
        </ul>

        <hr class="my-3">
        <h6 class="navbar-heading text-muted">Logout</h6>
        <ul class="navbar-nav mb-md-3">
          <a class="nav-link" @click="logout">
            <i class="ni ni-ui-04"></i> Cerrar Sesión
          </a>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import NavbarToggleButton from '@/components/NavbarToggleButton'

export default {
  name: 'sidebar',
  components: {
    NavbarToggleButton
  },
  props: {
    logo: {
      type: String,
      default: 'img/brand/green.png',
      description: 'Sidebar app logo'
    },
    Logo_Negativo:{
      type: String,
      default: 'img/brand/Logo-sitio.png',
      description: 'Sidebar app logo'
    },
    autoClose: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true)
    },
    logout() {
      // Eliminar el token de almacenamiento local o cookies
      this.clearAuthData();

      // Redirigir al usuario a la página de inicio de sesión
      this.$router.push("/login");
    },
    clearAuthData() {
      // Eliminar token de localStorage
      localStorage.removeItem("token");
      
      // Eliminar cookies (si las usas)
      this.deleteCookie("token");
    },
    deleteCookie(name) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
